module.exports = __webpack_public_path__ + "static/media/iq.ec59ec76.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/iq.svg
// module id = 2119
// module chunks = 0